import { $authHost } from ".";

export async function getState() {
    const { data } = await $authHost.get('/api/state')
    // console.log(data)
    return data
}

export async function getGraphs(hostid, name, from ,to) {
    try {
        // console.log(hostid)
        const { data } = await $authHost.post('/api/graphs', {hostid, name, from, to})
        return data
    } catch(e) {
        console.log(e)
    }
}

export async function execScript({hostid, name}, script, notify) { 
    const scriptid = script.id
    $authHost.post('/api/script/exec', {hostid, scriptid}, { timeout: 30000}).then(res => {
        // console.log(res)
        notify('success', {head: name, body: `${script.name}: успешно выполнено`})
    }).catch(err => {
        console.log(err)
        notify('alert', {head: name, body: `${script.name}: ошибка`})
    })
    
}


// Функции для работы с photos
export async function getPhoto(hostid, time) {
    try {
        // console.log(time)
        const { data } = await $authHost.post(`/api/photos/single`, {id: hostid, time}, { timeout: 30000})
        // console.log(data)
        return data

    } catch(e) {
        console.log(e)
        throw e
    } 
}

export async function getPhotosTimeline(hostid) {
    try {
        // console.log(hostid)
        const { data } = await $authHost.post(`/api/photos/timeline`, {id: hostid}, { timeout: 30000})
        // console.log(data)
        return data
    } catch(e) {
        console.log(e)
    } 
}

// Функции для работы с archive
export async function getArchiveTimeline(id) {
    try {
        const { data } = await $authHost.post('/api/archive/timeline', {id}, { timeout: 30000})
        // Преобразуем структуру данных для совместимости
        return data.map(item => ({
            time: item.time,
            vPrViol: item.viol || null,
            vRegno: item.grz || null
        }))
    } catch(e) {
        console.log(e)
        throw e
    } 
}

export async function getArchiveSingle(id, time) {
    try {
        const { data } = await $authHost.post('/api/archive/single', {id, time}, { timeout: 30000})
        // Убеждаемся, что videos всегда присутствует (может быть null)
        return {
            ...data,
            videos: data.videos || null
        }
    } catch(e) {
        console.log(e)
        throw e
    } 
}

// Загрузка только изображений (быстрая)
export async function getArchiveImages(id, time) {
    try {
        const { data } = await $authHost.post('/api/archive/images', {id, time}, { timeout: 30000})
        return data
    } catch(e) {
        console.log(e)
        throw e
    } 
}

// Загрузка только видео (фоновая, с поддержкой отмены)
export async function getArchiveVideos(id, time, signal) {
    try {
        const { data } = await $authHost.post('/api/archive/videos', {id, time}, { 
            timeout: 60000, // больший таймаут для видео
            signal // AbortController.signal для отмены запроса
        })
        return data
    } catch(e) {
        // Не логируем ошибки отмены
        if (e.name !== 'CanceledError' && e.code !== 'ERR_CANCELED') {
            console.log(e)
        }
        throw e
    } 
}

export async function downloadArchiveXml(id, time) {
    try {
        const { data } = await $authHost.post('/api/archive/xml', {id, time}, { timeout: 30000, responseType: 'blob' })
        return data
    } catch(e) {
        console.log(e)
        throw e
    }
}

// Получение скриншотов (data.xml + фото) с сервера avto5/avto6 по carid
export async function getScreenshots(server, carid) {
    try {
        const { data } = await $authHost.post('/api/screenshots', { server, carid }, { timeout: 120000 })
        return data
    } catch(e) {
        console.log(e)
        throw e
    }
}
